import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditOdpPozw = (props) => {
  const [value, setValue] = useState(props.client.bank_old);
  const [loading, setLoading] = useState(false);
  const [lawyerOptions, setLawyerOptions] = useState([]);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        value: value,
      };

      fetch("https://apidevkppp.ftpeople.pl/addOdpPozwClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o odpowiedzi na pozew",
        props.client.id
      );

      MySwal.fire({
        icon: "success",
        title: "Edytowano",
        text: "sprawę",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  useEffect(() => {
    setLawyerOptions(createLawyerOptions());
  }, []);

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createYesNoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ label: "TAK", value: "TAK" });
    statusOptions.push({ label: "NIE", value: "NIE" });
    statusOptions.push({ label: "Brak danych", value: "Brak danych" });

    return statusOptions;
  };

  const createLawyerOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({ label: "TAK", value: "TAK" });
    bankOptions.push({ label: "NIE", value: "NIE" });
    bankOptions.push({ label: "BRAK DANYCH", value: "BRAK DANYCH" });

    return bankOptions;
  };

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje o sprawie</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                Odpowiedź na pozew <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={lawyerOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditOdpPozw;
